import { decodeJwt } from "@/services/JwtService/JwtService";
import { UserRole } from "@/types/user";

export const JWT_ROLE_TO_USER_ROLE: Record<string, UserRole> = {
  admin: UserRole.ADMIN,
  editor: UserRole.EDITOR,
  viewer: UserRole.VIEWER,
};

export const getRoleFromToken = (token: string): UserRole | undefined => {
  const payload = decodeJwt(token);
  if (!payload?.role) return undefined;
  return JWT_ROLE_TO_USER_ROLE[payload.role] ?? undefined;
};
